import { ChangeDetectionStrategy,Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { ViewContext, ViewContextService } from 'app/navigation/view-context.service';
import { ErrorComponent } from 'app/shared/components/error.component';

import { PageStatus } from './page-status';

@Component({
    selector: 'admin-page-simple-content',
    templateUrl: './page-simple-content.component.html',
    styleUrls: ['./page-simple-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIcon, MatProgressSpinner, ErrorComponent]
})
export class PageSimpleContentComponent implements OnInit, OnChanges, OnDestroy {
    titleService = inject(Title);
    viewContextService = inject(ViewContextService);
    route = inject(ActivatedRoute).snapshot;

    @Input() title: string;
    @Input() icon: string;
    @Input() pageStatus: PageStatus = PageStatus.loading;
    @Input() pageError?: Error;

    viewContext?: ViewContext;
    subscription = new Subscription();

    constructor() {
    }

    ngOnInit() {
        this.subscription.add(this.viewContextService.context$.subscribe((context: ViewContext) => {
            this.viewContext = context;
            this.updateTitle();
        }));
        this.updateTitle();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.updateTitle();
    }

    private updateTitle() {
        let title = 'Mediaclip - ';
        if (this.route.data.viewContextType !== 'global') {
            if (this.viewContext) {
                switch (this.viewContext.type) {
                    case 'library':
                        title += ` Lib: ${this.viewContext.libraryOwner} - `;
                        break;
                    case 'fulfiller':
                        title += ` Fulfiller: ${this.viewContext.fulfillerId} - `;
                        break;
                    case 'subscription':
                        title += ` Sub: ${this.viewContext.subscriptionLabel} - `;
                        break;
                    case 'store':
                        title += ` Store: ${this.viewContext.storeId} - `;
                        break;
                    case 'none':
                        break;
                }
            }
        }
        title += this.title;
        this.titleService.setTitle(title);
    }
}
